exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".compute-content-area {\n  padding-top: 24px; }\n\n.select-entity-container {\n  position: absolute;\n  top: 25%;\n  left: 25%;\n  background-color: #fff;\n  z-index: 2;\n  width: 50%;\n  border: 1px solid #9a9a9a;\n  padding: 10px;\n  height: 250px;\n  box-shadow: 2px 2px 2px #888888; }\n  .select-entity-container .action-icons {\n    float: right;\n    cursor: pointer; }\n  .select-entity-container .dialog-title {\n    font-weight: bold; }\n  .select-entity-container .modal-footer button {\n    float: right; }\n\n.icon-inactive {\n  opacity: 0.5;\n  cursor: default; }\n\n.icon-active {\n  opacity: 1;\n  cursor: pointer; }\n\n.add-edit-dc clr-icon {\n  margin-right: 5px;\n  cursor: pointer; }\n\n.deployment-container .toolbar {\n  padding-left: 0px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/administration-main/deployment-container/dc.scss
// module id = GIXk
// module chunks = 0